import React from 'react';

// - Add '.fill' to all body classes.
// - Add '.tail' <g> around tail. Remember to add '.fill' to tail shape so that:
	// <g .tail > <path .fill /> </g>

export default function Bodies() {
	return (
		<g>
			<g className="wing wing--left">
				<path className="fill fill--dark" d="M228.95879,243.4124c0,0,10.53212,61.71434-36.12633,61.71434
					c-16.89166,0-30.58505-8.97876-30.58505-31.08014s13.69339-40.0181,30.58505-40.0181S228.95879,243.4124,228.95879,243.4124z" />
			</g>
			<path className="fill thigh thigh--right" d="M314.60611,305.12671c-19.61865,39.74072-40.62469,51.84012-60.61441,32.22366
				c-19.12944-19.12946,7.78482-42.00516,24.51871-51.11209C302.46719,273.20068,320.64883,289.06592,314.60611,305.12671z" />
			<path className="fill thigh thigh--left" d="M181.42679,305.12671c19.61865,39.74072,40.62471,51.84012,60.61444,32.22366
				c19.12943-19.12946-7.78485-42.00516-24.51874-51.11209C193.5657,273.20068,175.38406,289.06592,181.42679,305.12671z" />
			<g className="tail">
				<path className="fill" d="M328.97482,228.75055c-3.06363,6.14191-11.92139,7.94139-11.92139,7.94139
					s-3.89059-8.15849-0.82697-14.3004c1.21512-2.43602,3.34171-4.18893,5.46558-5.41742
					c3.41086-1.97285,7.82019,0.15784,8.31241,4.06728C330.31375,223.49765,330.20398,226.28639,328.97482,228.75055z" />
				<path className="fill" d="M331.09857,239.50623c-6.50931,2.17665-14.04514-2.81429-14.04514-2.81429
					s3.01785-8.52,9.52716-10.69666c2.61157-0.87329,5.38834-0.59285,7.7774,0.05614c3.80252,1.03293,5.29712,5.69643,2.86761,8.79861
					C335.7128,236.78172,333.6803,238.64291,331.09857,239.50623z" />
				<path className="fill" d="M319.86774,222.64682c2.17664,6.50931-2.8143,14.04512-2.8143,14.04512
					s-8.51999-3.01785-10.69666-9.52716c-0.87329-2.61156-0.59283-5.38834,0.05612-7.7774
					c1.03296-3.80251,5.69644-5.2971,8.79865-2.8676C317.14322,218.03258,319.00439,220.06508,319.86774,222.64682z" />
			</g>
			<path className="fill" d="M302.43628,319.19c23.6463-23.26318,24.72998-80.66725,24.72998-80.66725
				s-33.75958-27.60931-79.15903-27.60931" />
			<path className="fill" d="M248.00723,210.91344c40.49014,0,73.3139,23.73068,73.3139,64.22081
				c0,43.41525-32.82376,62.26218-73.3139,62.26218s-73.31389-18.84692-73.31389-62.26218
				C174.69334,234.64412,207.51709,210.91344,248.00723,210.91344z" />
		</g>
	);
}



// WEBPACK FOOTER //
// ./src/components/Global/Pet/Chicken/Bodies.js